<div class="wrapper" [ngClass]="{ mobile: isMobile }">
  <app-shared-layout-topbar></app-shared-layout-topbar>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
